import { useEffect } from 'react';
import { createPortal } from 'react-dom';

export default function Modal({ children, onClose, maxWidth }) {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape' && onClose) onClose(); };
    document.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  return createPortal(
    <div
      className="modal-overlay"
      onClick={e => e.target === e.currentTarget && onClose && onClose()}
    >
      <div className="modal" style={maxWidth ? { maxWidth } : undefined}>
        {children}
      </div>
    </div>,
    document.body
  );
}
